import { defineCustomElement } from 'vue'
import RoomCalculator from '../RoomCalculator.vue'

const ensureAssetBase = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (!document.currentScript?.src) return
  const scriptUrl = new URL(document.currentScript.src, window.location.href)
  const base = scriptUrl.pathname.includes('/src/entries/')
    ? `${scriptUrl.origin}/`
    : new URL('./', scriptUrl).toString()
  window.__WIDGET_ASSET_BASE__ = window.__WIDGET_ASSET_BASE__ || {}
  if (typeof window.__WIDGET_ASSET_BASE__ === 'string') return
  window.__WIDGET_ASSET_BASE__.room = base
  window.__WIDGET_ASSET_BASE__.default = window.__WIDGET_ASSET_BASE__.default || base
}
ensureAssetBase()
if (typeof window !== 'undefined') {
  window.__WIDGET_MODE__ = true
  if (!window.__WIDGET_API_BASE__ && document.currentScript?.src) {
    const scriptUrl = new URL(document.currentScript.src, window.location.href)
    window.__WIDGET_API_BASE__ = `${scriptUrl.origin}/api`
  }
}

const STYLE_ID = 'room-calculator-styles'
const ensureShadowStyles = (shadowRoot) => {
  if (!shadowRoot) return
  if (shadowRoot.querySelector(`style[data-style-id="${STYLE_ID}"]`)) return
  const cssText = window.__WIDGET_CSS__?.[STYLE_ID]
  if (!cssText) return
  const style = document.createElement('style')
  style.setAttribute('data-style-id', STYLE_ID)
  style.textContent = cssText
  shadowRoot.appendChild(style)
}

const RoomCalculatorElementBase = defineCustomElement(RoomCalculator)
class RoomCalculatorElement extends RoomCalculatorElementBase {
  connectedCallback() {
    super.connectedCallback?.()
    ensureShadowStyles(this.shadowRoot)
  }
}

if (!customElements.get('room-calculator')) {
  customElements.define('room-calculator', RoomCalculatorElement)
}

const mount = (target, props = {}) => {
  const el = typeof target === 'string' ? document.querySelector(target) : target
  if (!el) return null
  const node = document.createElement('room-calculator')
  if (props.lang) {
    node.setAttribute('lang', props.lang)
  }
  if (props.market) {
    node.setAttribute('market', props.market)
  }
  el.appendChild(node)
  return node
}

window.RoomCalculator = {
  mount,
}
